<template>
  <div class="w-full relative" id="eggLabelList">
    <title-w-star :title="title" :titleColor="titleColor" :starIconObj="starIconObj" />

    <div class="absolute -z-10" style="width: 9.5vw" :style="starBackgroundObj.position" v-if="starBackgroundObj.componentName != undefined">
      <img :src="commonStore.getImgUrl(starBackgroundObj.componentName, starBackgroundObj.imgName, starBackgroundObj.imgFormat)" />
    </div>
    <div class="flex justify-center space-x-24">
      <div v-for="(item, index) in eggIconLabelList" :key="index" class="flex flex-col items-center">
        <div class="relative mb-10">
          <img :src="commonStore.getImgUrl(eggBackgroundObj.componentName, eggBackgroundObj.imgName, eggBackgroundObj.imgFormat)" v-if="item.eggBackgroundObj == undefined" style="width: 13.6vw" />
          <img :src="commonStore.getImgUrl(item.eggBackgroundObj.componentName, item.eggBackgroundObj.imgName, item.eggBackgroundObj.imgFormat)" v-else style="width: 13.6vw" />
          <img
            :src="commonStore.getImgUrl(item.eggIconObj.componentName, item.eggIconObj.imgName, item.eggIconObj.imgFormat)"
            v-if="(item.eggIconObj != undefined && Object.keys(item.eggIconObj).length) != 0"
            class="absolute"
            style="height: 5.9rem; top: 50%; left: 50%; transform: translate(-50%, -50%)"
            :style="eggIconSize(item.eggIconObj.width, item.eggIconObj.height)"
          />
        </div>
        <div class="font-jost text-center" :style="'color:' + labelColor" v-html="t(item.label)" :class="[isTextBold ? 'font-bold text-2xl ' : 'font-jost text-sm']" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { useCommonStore } from "@/stores/common";
import { useI18n } from "vue-i18n";

const commonStore = useCommonStore();
const { t, locale } = useI18n();

onMounted(async () => {});

import { toRefs } from "vue";

const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  titleColor: {
    type: String,
    default: "#494949",
  },
  starIconObj: {
    type: Object,
    default: {},
    //{ componentName: 'telemedicine', imgName: 'starIconLightBlue', imgFormat: 'svg' }
  },
  starBackgroundObj: {
    type: Object,
    default: {},
    //{ componentName: 'telemedicine', imgName: 'starIconLightBlue', imgFormat: 'svg' }
  },
  eggBackgroundObj: {
    type: Object,
    default: {},
    //{ componentName: 'telemedicine', imgName: 'starIconLightBlue', imgFormat: 'svg' }
  },
  labelColor: {
    type: String,
    default: "#494949",
  },
  isTextBold: {
    type: Boolean,
    default: true,
  },
  eggIconLabelList: {
    type: Array,
    default: [],
    //[
    //eggIconObj: {componentName: 'telemedicine', imgName: 'starIconLightBlue', imgFormat: 'svg', width: '30vw'},
    //eggBackgroundObj: {componentName: 'telemedicine', imgName: 'starIconLightBlue', imgFormat: 'svg',},
    //label: 'corporate.label'
    //}]
  },
});
const { starBackgroundObj } = toRefs(props);
if (starBackgroundObj.value.position == undefined) starBackgroundObj.value.position = "left:0;top: 10%;";

const eggIconSize = (width, height) => {
  let style = "";
  if (width != undefined) style = style + "width: " + width + ";";
  if (height != undefined) style = style + "height: " + height + ";";
  return style;
};
</script>

<style>
</style>